/*
 *
 * App constants
 *
 */

export const SET_AUTH_TOKEN = 'src/App/SET_AUTH_TOKEN';
export const SET_USER       = 'src/App/SET_USER';
export const SIGN_OUT       = 'src/App/SIGN_OUT';
export const NOOP           = 'src/App/NOOP'
// Re-request the restored session. Dispatched by the retry affordance on a
// route that cannot render until the session is known.
export const FETCH_SESSION  = 'src/App/FETCH_SESSION';
// The session restore failed for a reason that is NOT an auth rejection — a
// network drop, a timeout, a 5xx. An auth rejection signs out instead.
export const SESSION_LOAD_FAILED = 'src/App/SESSION_LOAD_FAILED';
